<script setup>
import { ref } from 'vue'
import OutlineButton from '../buttons/OutlineButton.vue'
const props = defineProps({
    upperTitle: {
        type: String,
        default: 'L’application révolutionnaire'
    },
    title: {
        type: String,
        default: 'Un agent IA dédié aux commissaires de justice'
    },
    buttonLabel: {
        type: String,
        default: 'Découvrir'
    },
    backgroundImage: {
        type: String,
        default: ''
    },
    backgroundImageDesktop: {
        type: String,
        default: ''
    }
})

</script>

<template>
     <section class="hero-banner">
        <div class="hero-content">
            <p class="hero-upper-title">{{ upperTitle }}</p>
            <h1 class="hero-title">{{ title }}</h1>
            <OutlineButton
                class="hero-btn"
                :label="buttonLabel"
                link="/logiciel-360"
            />
        </div>
        <div>
        <NuxtImg
            class="hero-image"
            :src="backgroundImageDesktop"
            layout="fill"
            objectFit="cover"
            alt="Background Stars"
            loading="eager"
        />
        </div>
    </section>
</template>

<style lang="scss" scoped>
.hero-banner {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 auto;
    flex-direction: column;
    gap: 40px;  
    padding: 125px 0 50px;
    max-width: 1350px;

    & .hero-content {
        text-align: center;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 15px;
        width: 100%;
        max-width: 525px;
        z-index: 1;

        & .hero-upper-title {
            text-align: center;
            font-family: $tertiary-font-family;
            font-size: $upper-title-size;
            line-height: $upper-title-line-height;
            background: $title-background-gradient--blue;
            background-clip: text;
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            margin-bottom: 0;
        }

    
        & .hero-btn {
            margin-top: 20px;
        }
    }

    & .hero-image {
        width: 100%;
        display: flex;
        justify-content: center;
        height: 50vh;
        object-fit: cover;
        object-position: center;
        position: absolute;
        top: 0;
        right: 0;
        z-index: 0;
        opacity: .2;
    }

 
}

// Responsive
@media (min-width: 767px) {
    .hero-banner {
        padding: 0;

        & .hero-content {
            text-align: left;
            align-items: flex-start;
        }
        min-height: 100vh;
        flex-direction: row;
        gap: 50px;  

        & .hero-upper-title{
            font-size: 28px;
        }

         & .hero-image {
            width: 81%;
            height: 80vh;
            z-index: 0;
            opacity: 1;
            /* Masque avec dégradé transparent (gauche et bas) */
            -webkit-mask-image: linear-gradient(to right, transparent, black 20%), 
                                linear-gradient(to top, transparent, black 20%);
            -webkit-mask-composite: destination-in;
            mask-image: linear-gradient(to right, transparent, black 20%), 
                        linear-gradient(to top, transparent, black 20%);
            mask-composite: intersect;

            /* Pour Safari/Chrome */
            -webkit-mask-repeat: no-repeat;
            -webkit-mask-position: left, bottom;
            -webkit-mask-size: 100% 100%;
        }

    }
}

</style>